module.exports = __webpack_public_path__ + "static/media/choithramsFavourite.8a459c7d.png";